module.exports = __webpack_public_path__ + "img/trademark-6.f6a0c358.png";